export const isStaging = window.location.hostname.includes('framer.app');